import logo from 'assets/images/logo/cz.png';
// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
    return <img src={logo} alt="Mantis" width="100" />;
};

export default Logo;
